// 등급 색 단일 소스. 값을 바꾸면 globals.css 의 --color-severity-* 도 같이 바꾼다
// (pnpm check:palette 가 검사). Tailwind v4 램프.
//
// CSS 변수가 아니라 hex 인 이유: 지도 마커가 SVG fill 속성에 꽂는데 속성은 var() 를 못 받는다.

/** 백엔드 EventResponse.severity 와 같은 집합 */
export type SeverityKey = "NORMAL" | "UNCERTAIN" | "ATTENTION" | "CAUTION" | "WARNING" | "CRITICAL";

// 글자가 얹히는 면에 fill 을 쓰지 말 것 — 500단 위 흰 글자는 여섯 등급 전부 AA 미달
// (노랑 1.91:1). 글자가 있으면 chipBg+chipFg(5.4~11.9:1).
//
// 각 역할의 `/** 500 */` 주석은 장식이 아니라 램프 단 선언이다 — check:palette 가
// 이걸 읽어 globals.css 의 어느 토큰과 맞출지 정한다. 지우면 검사가 멈춘다.
export interface SeverityRoles {
  /** 500 — 글자 없는 채움 */
  fill: string;
  /** 300 */
  mutedFill: string;
  /** 200 */
  chipBg: string;
  /** 800 */
  chipFg: string;
  /** 50 */
  panelBg: string;
  /** 700 */
  panelFg: string;
}

export const SEVERITY_PALETTE: Record<SeverityKey, SeverityRoles> = {
  NORMAL: {
    fill: "#00C950",
    mutedFill: "#7BF1A8",
    chipBg: "#B9F8CF",
    chipFg: "#016630",
    panelBg: "#F0FDF4",
    panelFg: "#008236",
  },
  UNCERTAIN: {
    fill: "#62748E",
    mutedFill: "#CAD5E2",
    chipBg: "#E2E8F0",
    chipFg: "#1D293D",
    panelBg: "#F8FAFC",
    panelFg: "#314158",
  },
  ATTENTION: {
    fill: "#2B7FFF",
    mutedFill: "#8EC5FF",
    chipBg: "#BEDBFF",
    chipFg: "#193CB8",
    panelBg: "#EFF6FF",
    panelFg: "#1447E6",
  },
  CAUTION: {
    fill: "#F0B100",
    mutedFill: "#FFDF20",
    chipBg: "#FFF085",
    chipFg: "#894B00",
    panelBg: "#FEFCE8",
    panelFg: "#A65F00",
  },
  WARNING: {
    fill: "#FF6900",
    mutedFill: "#FFB86A",
    chipBg: "#FFD6A7",
    chipFg: "#9F2D00",
    panelBg: "#FFF7ED",
    panelFg: "#CA3500",
  },
  CRITICAL: {
    fill: "#FB2C36",
    mutedFill: "#FFA2A2",
    chipBg: "#FFC9C9",
    chipFg: "#9F0712",
    panelBg: "#FEF2F2",
    panelFg: "#C10007",
  },
};
